module.exports = __webpack_public_path__ + "static/media/1040912600.e13a80fb.jpg";